import React, { useState, useEffect } from "react";
import "./AdaptiveCpsContent.scss";
import { useHistory } from "react-router";

import AdaptiveCpsBanner from "./adaptiveCpsBanner/AdaptiveCpsBanner";
import LoaderPopUp from "../../../../../../../components/loader/loader";
import { connect } from "react-redux";
import images from "../../../../../../../utilities/images/images";
import axios from "axios";
import adaptiveCpsActions from "../../../../../../../redux/adaptive_cps/action";
import AdaptiveCpsSubjects from "./adaptiveCpsSubjects/AdaptiveCpsSubjects";
import CommonBannerComponent from "../../../../../PYQ_CPS_Exam/pyqCpsExamComponent/PyqCpsExamContentComponent/CommonBannerComponent";

const AdaptiveCpsContent = ({
  loader,
  handleStep,
  packageList,
  token,
  tokenType,
  setAdaptiveCpsSubjectAction,
  startLoading,
  finishLoading,
}) => {
  const history = useHistory();
  const [attemptCount, setAttemptCount] = useState("");
  const [alertShow, setAlertShow] = useState(false);

  useEffect(() => {
    getAttemptCount();
  }, []);

  const getAttemptCount = async () => {
    const headers = {
      Authorization: `${tokenType} ${token}`,
    };
    startLoading();
    try {
      const response = await axios.post(
        "https://learning.motion.ac.in/motioneducation/api/user/UserACPSInstructions",
        { headers }
      );

      if (response.data.status === 200) {
        finishLoading();
        setAttemptCount(response?.data?.TotalAttempt);
      }
    } catch (error) {
      finishLoading();
      console.log(error);
    }
  };

  const handleSubjectClick = (sub_name) => {
    if (attemptCount === 0) {
      setAlertShow(true);
    } else {
      setAdaptiveCpsSubjectAction(sub_name);
      history.push({
        pathname: "/adaptive_cps_test",
        state: { attemptCount: attemptCount },
      });
    }
  };

  const handleSubjectClick2 = (sub_name) => {
    setAdaptiveCpsSubjectAction(sub_name);
    history.push({
      pathname: "/adaptive_cps_test",
      state: { attemptCount: attemptCount },
    });
  };

  const handleClose = () => {
    setAlertShow(false);
  };

  const handleRedirectToStore = () => {
    setAlertShow(false);
    history.push("/dashboard/courses");
  };

  // Check if any package matches the condition
  const hasMatchingPackage = packageList.some(
    (packageItem) =>
      packageItem.package_id === 228 || packageItem.package_id === 229
  );

  // Determine is_subscribe based on the matching package(s)
  const matchingPackage = packageList.find(
    (packageItem) =>
      packageItem.package_id === 228 || packageItem.package_id === 229
  );
  const isSubscribed = matchingPackage ? matchingPackage.is_subscribe : false;

  return (
    <>
      <div className="acpsBackBtn" onClick={() => handleStep(1)}>
        
      </div>
      <div>
        <div className="containerr">
          <div className="Acps_Wrapper">
            <div className="Acps_InrWrapper">
              <div className="Acps_contentWpr">
                <div className="Acps_header">
                  <p>
                    Based on the exams & practice test performances we suggested
                    you to keep focus on weak topics.
                  </p>
                </div>
                <CommonBannerComponent tab="adaptive_cps" />
                <div className="adaptive-cps-containers">
                  {/* Render AdaptiveCpsSubjects only once if a matching package exists */}
                  {hasMatchingPackage && (
                    <div className="adaptive-cps-subjects">
                      <AdaptiveCpsSubjects
                        handleSubjectClick={handleSubjectClick} // Pass handleSubjectClick
                        handleSubjectClick2={handleSubjectClick2}
                        is_subscribe={isSubscribed}
                        startLoading={startLoading}
                        finishLoading={finishLoading}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        {loader && <LoaderPopUp />}
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    loader: state.ui.loader,
    packageList: state.auth.packageList.paidCoursePackages,
    token: state.auth.authToken,
    tokenType: state.auth.authType,
  };
};

const mapDipatchToProps = (dispatch) => {
  return {
    setAdaptiveCpsSubjectAction: (payload) => {
      dispatch(adaptiveCpsActions.setAdaptiveCpsSubject(payload));
    },
  };
};

export default connect(mapStateToProps, mapDipatchToProps)(AdaptiveCpsContent);
